export default __webpack_public_path__ + "static/image1-e8678dc922c34d4860eaa0d55df5296e.webp";